import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"

class DashboardAllpiechart extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      series: [10, 10, 40, 25,15],
      options: {
        labels: ["Email Campaign", "Google Ads", "Facebook Ads", "Referral","Landing Pages"],
        colors:['#66C2A5', '#FFD92F','#A6D854','#E78AC3','#92A5D2'],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
          offsetY: -10,
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    }
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="pie"
          height="320"
          className="apex-charts"
        />
      </React.Fragment>
    )
  }
}

export default DashboardAllpiechart
